import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenMetadataController::__invoke
* @see app/Http/Controllers/Screen/GetScreenMetadataController.php
* @route '/api/screen/metadata'
*/
const GetScreenMetadataController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenMetadataController.url(options),
    method: 'get',
})

GetScreenMetadataController.definition = {
    methods: ["get","head"],
    url: '/api/screen/metadata',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenMetadataController::__invoke
* @see app/Http/Controllers/Screen/GetScreenMetadataController.php
* @route '/api/screen/metadata'
*/
GetScreenMetadataController.url = (options?: RouteQueryOptions) => {
    return GetScreenMetadataController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenMetadataController::__invoke
* @see app/Http/Controllers/Screen/GetScreenMetadataController.php
* @route '/api/screen/metadata'
*/
GetScreenMetadataController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenMetadataController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenMetadataController::__invoke
* @see app/Http/Controllers/Screen/GetScreenMetadataController.php
* @route '/api/screen/metadata'
*/
GetScreenMetadataController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenMetadataController.url(options),
    method: 'head',
})

export default GetScreenMetadataController